export default __webpack_public_path__ + "static/media/Kuthcheman War Axe.c336d891.jpg";